export const SearchIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
      <g fill="none" fillRule="evenodd" stroke="#F55058" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" transform="translate(1 1.5)">
        <circle cx="8" cy="8" r="8"/>
        <line x1="18" x2="13.65" y1="18" y2="13.65"/>
      </g>
    </svg>
	)
}